import React from "react";

import svg from "../../assets/images/icons/rule-table.svg";

export const RuleTableIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={svg}
        alt={alt || "Rule Table"}
    />
);
